import React from 'react';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import './LoadingProgress.css';

const LoadingProgress = ({ progress }) => {
  const { currentLanguage } = useSelector((state) => state.language);
  
  return (
    <div className="loading-progress-container">
      <div className="progress-bar">
        <motion.div 
          className="progress-fill"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 1, ease: "easeInOut" }}
        />
      </div>
      <span className="progress-text">
        {currentLanguage === 'en' ? 'Signing in...' : 'جاري تسجيل الدخول...'} {progress}%
      </span>
    </div>
  );
};

export default LoadingProgress;